import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'green' | 'orange';
  className?: string;
}
const variants: Record<'green' | 'orange', string> = {
  green: 'bg-brand-green text-white hover:bg-[#437f33] border-[#3b6d2e]',
  orange: 'bg-brand-orange text-white hover:bg-[#d4720f] border-[#b96110]'
};
export function CTAButton({
  children,
  href = '#offerta',
  variant = 'green',
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) return;
    e.preventDefault();
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <a href={href} onClick={handleClick} className={`inline-flex w-full items-center justify-center rounded-lg border-b-4 px-4 py-3.5 text-center font-display text-sm font-extrabold uppercase leading-tight tracking-tight shadow-lg transition-[background-color,transform] duration-150 ease-out active:translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-navy sm:text-base ${variants[variant]} ${className}`} data-id="element-32" data-mp="2ypt9pltzmj8u">
      {children}
    </a>;
}